import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import AppButton from "../../components/button/component";
import AppTextField from "../../components/text-field/component";
import Header from "../../components/header";
import Loader from "../../components/loader";
import { validateEmail, validatePassword } from "../../utils/validation";
import { toast } from "react-toastify";
import Footer from "../../components/footer";
import { getCookie } from "../../utils/utility-functions";
import { useTranslation } from "react-i18next";

function LoginAsAdmin({ loginUserAndAuthenticateConnect, isAdminUserConnect }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const token = getCookie("jwtToken");
  const [formData, setFormData] = useState({
    adminEmail: "",
    loginAsAdminEmail: "",
    adminPassword: "",
  });
  const { t } = useTranslation();

  const [error, setError] = useState({
    adminEmailError: "",
    loginAsAdminEmailError: "",
    adminPasswordError: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let error = "";
    if (name === "adminEmail" || name === "loginAsAdminEmail") {
      error = validateEmail(value);
    }
    if (name === "adminPassword") {
      error = validatePassword(value);
    }
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  };
  useEffect(() => {
    if (token) {
      navigate(ROUTE_CONSTANT.DASHBOARD_B);
    }
  }, [token]);

  const handleSignin = (event) => {
    event.preventDefault();
    const { adminEmail, adminPassword, loginAsAdminEmail } = formData;

    // Validate all fields before proceeding
    validateField("adminEmail", adminEmail.trim());
    validateField("adminPassword", adminPassword.trim());
    validateField("loginAsAdminEmail", loginAsAdminEmail.trim());

    // Check if there are any errors
    if (
      error.adminEmailError ||
      error.adminPasswordError ||
      error.loginAsAdminEmailError ||
      !adminEmail ||
      !adminPassword ||
      !loginAsAdminEmail
    ) {
      // If there are errors, show a toast message and prevent submission
      toast.error("Please fix the errors before submitting.");
      return; // Prevent submission if there are errors
    }

    const params = {
      adminUserName: adminEmail.trim(),
      password: adminPassword.trim(),
      userEmail: loginAsAdminEmail.trim(),
    };
    let userDetails = {
      adminUserName: adminEmail,
    };
    setIsLoading(true);
    isAdminUserConnect(userDetails)
      .then((res) => {
        if (!!res) {
          // If the user is an admin, proceed to the next step
          return loginUserAndAuthenticateConnect(params);
        } else {
          // Show error and prevent further actions
          toast.error(t("login.email_taken_msg"));
          throw new Error(t("login.admin_user_error_msg"));
        }
      })
      .then((response) => {
        if (!!response) {
          navigate(ROUTE_CONSTANT.DASHBOARD_B);
        } else {
          toast.error("login_fail");
        }
      })
      .catch((error) => {
        console.error("signin.signin_fail", error);
      })
      .finally(() => {
        setIsLoading(false); // Stop loader
      });
  };

  return (
    <div>
      <Header />
      <div className="p-5 text-center bg-white flex-grow flex flex-col justify-center items-center">
        <h1 className="font-bold color-[#444C5E] text-4xl mb-4">
          Login As Admin
        </h1>
        <Loader isLoading={isLoading} />
        <div className="flex justify-center mt-8 w-full max-w-xs">
          <form className="space-y-4 w-full max-w-xs" onSubmit={handleSignin}>
            <AppTextField
              label="Admin Email"
              name="adminEmail"
              onChange={handleInputChange}
              value={formData.adminEmail}
              error={error.adminEmailError}
              placeholder="Enter your email"
            />
            <AppTextField
              label="Login As Email"
              name="loginAsAdminEmail"
              onChange={handleInputChange}
              value={formData.loginAsAdminEmail}
              error={error.loginAsAdminEmailError}
              placeholder="Enter your email"
            />
            <AppTextField
              label="Admin Password"
              name="adminPassword"
              onChange={handleInputChange}
              value={formData.adminPassword}
              error={error.adminPasswordError}
              type="password"
              placeholder="Enter your password"
            />

            <AppButton
              type="submit"
              className="bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 text-white"
            >
              Log In
            </AppButton>
          </form>
        </div>
      </div>
      <Footer className="fixed" />
    </div>
  );
}

export default LoginAsAdmin;
